import { filter, takeUntil } from 'rxjs/operators';
import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { Constant } from 'src/app/constant/constant';
import { LeadStatusService } from 'src/app/services/lead-status.service';
import { MatTableDataSource } from '@angular/material/table';
import { LeadSourceService } from 'src/app/services/lead-source.service';
import { ProductService } from 'src/app/services/product.service';
import { LeadService } from 'src/app/services/lead.service';
import icPhone from '@iconify/icons-ic/twotone-phone';
import icWhatsapp from '@iconify/icons-mdi/whatsapp';
import { CrmsettingsService } from 'src/app/services/crmsettings.service';
import { MatDialog } from '@angular/material/dialog';
import { ConversationPopupComponent } from 'src/app/shared/conversation-popup/conversation-popup.component';
import { LeadActivityService } from 'src/app/services/lead-activity.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LoaderService } from 'src/app/services/loader.service';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { EcryptServiceService } from 'src/app/core/auth/EcryptionService/ecrypt-service.service';
import { CommonService } from 'src/app/services/common.service';
import { ResourceAccess } from 'src/app/shared/utils/calsoft-validators';
import { Subject } from 'rxjs';

@Component({
  selector: 'calsoft-crmdealskanban',
  templateUrl: './crmdealskanban.component.html',
  styleUrls: ['./crmdealskanban.component.scss'],
})
export class CrmdealskanbanComponent implements OnInit, OnDestroy {

  url = '';
  sanitizedUrl = '';


  @Input() kanbanviewType: any = 1;
  @Input() resourcePrivilege: any;
  read: boolean = false;
  leadStatusList: any;
  filterActive: boolean = false;
  spinner: boolean;
  leadList: MatTableDataSource<unknown>;
  elements: any;
  sort: any;
  paginator: any;
  pageList: any;
  pageSizeValue: number[];

  search: string;
  productList: any;
  icPhone = icPhone;
  icWhatsapp = icWhatsapp;
  leadDetailPageType: any;
  crmType: any;
  leadId: any;
  whatsAppCustomUrl: any = 0;
  whatAppUrl: any;
  storeName: any;
  storeNameAdded: boolean;
  dialerType: any;
  leadDetailType: any;
  crmSettingsData: any;
  defaultSet: null;
  configData: any;
  defaultBackgroundcolor: any;
  defaultTextcolor: any;
  storename: any;

  connectedLeadIds: any[] = [];

  constructor(
    private cdr: ChangeDetectorRef,
    private leadStatusService: LeadStatusService,
    private leadSourceService: LeadSourceService,
    private ecryptService: EcryptServiceService,
    private productService: ProductService,
    private leadService: LeadService,
    private crmsettingsService: CrmsettingsService,
    private dialog: MatDialog,
    private leadActivityService: LeadActivityService,
    private snackBar: MatSnackBar,
    private loaderService: LoaderService,
    private router: Router,
    private route: ActivatedRoute,
    private commonService: CommonService,
  ) {
    this.url = this.router.url || '';
    this.sanitizedUrl = this.sanitizeUrl(this.url);
    this.router.events.pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy)).subscribe(() => {
      this.url = this.router.url || '';
      this.sanitizedUrl = this.sanitizeUrl(this.url);
    });

    this.url = this.router.url || '';
    this.router.events
      .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
      .subscribe(() => { this.url = this.router.url || ''; });
  }


  columnConnections: string[] = [];

  contactPage: boolean = false;

  title: string;

  connectedCall: boolean = false;

  getConnectedCallsIds() {
    if (this.connectedCall) {
      let encryptedData = this.route.snapshot.params['leadId'];
      if (!encryptedData && this.route.parent) {
        encryptedData = this.route.parent.snapshot.params['leadId'];
      }
      if (encryptedData) {
        try {
          const decrypted = this.ecryptService.decryptionAES(encryptedData);
          if (decrypted) {
            this.connectedLeadIds = decrypted.split(',');
          }
        } catch (err) {
          console.error("Error decrypting connectedCalls leadId in kanban", err);
        }
      }
    }
  }

  ngOnInit() {

    if (!this.resourcePrivilege) {
      this.getResource();
    }

    if (this.router.url.includes('contact')) {

      this.contactPage = true;

    } else {

      this.contactPage = false;

    }

    if (this.router.url.includes('connectedCalls')) {

      this.title = 'connectedCalls';

      this.connectedCall = true;

      this.getConnectedCallsIds();

    }

    let storename: any;

    const encrypted = localStorage.getItem('crmSettingsData');
    if (encrypted) {
      try {
        const decrypted = this.ecryptService.decryptionAES(encrypted);
        this.crmSettingsData = JSON.parse(decrypted);

        if (this.crmSettingsData != null) {

          this.storename = this.crmSettingsData.storeName;

          if (this.crmSettingsData['dealsKanbanViewType'] != undefined) {
            this.kanbanviewType = this.crmSettingsData['dealsKanbanViewType'];
          } else {
            this.kanbanviewType = 1;
          }

        }

        if (this.url.includes("/lead")) {

          if (this.kanbanviewType == 3) {

            this.kanbanviewType = 1;
          }

        }

      } catch (err) {
        console.error("Error decrypting crmSettingsData", err);
      }
    }
    const encryptedData = localStorage.getItem('configSettingsData');
    if (encryptedData) {
      try {
        const decrypted = this.ecryptService.decryptionAES(encryptedData);
        const data = JSON.parse(decrypted);
        this.configData = data;
        this.defaultBackgroundcolor = data['leftMenuBgColor'];
        this.defaultTextcolor = data['leftMenuColor']
        console.log("the data is ", this.configData);

      } catch (error) {
        console.error("Failed to decrypt crmSettingsData:", error);
      }
    }
    this.getAllCrmData();

    this.getLeadStatus();

    if (storename != undefined) {
      this.storeNameAdded = true;
      this.storeName = storename;

    } else {
      this.storeNameAdded = false;
    }
  }

  getResource() {
    let access = ResourceAccess.LEAD;
    if (this.router.url.includes('contact')) {
      access = ResourceAccess.CONTACT;
    }
    this.commonService
      .getAllAccessForResource(access)
      .subscribe((data: any) => {
        if (!data.read) {
          this.router.navigate(['/unauthorized']);
        } else {
          this.read = true;
          this.resourcePrivilege = data;
        }
      });
  }

  public dropGrid(event: CdkDragDrop<string[]>): void {
    moveItemInArray(this.leadStatusList, event.previousIndex, event.currentIndex);
  }

  public page: any = Constant.PAGE;
  public size: any = Constant.SIZE;
  sortParam: any = 'statusId' + "," + Constant.Dsc;
  type: any = 0;


  getLeadStatus() {
    this.leadStatusService.getAllLeadStatusDropDownCache().subscribe(
      res => {
        this.leadStatusList = res.map(column => {
          const statusColor = (column.statusColor !== null && column.statusColor !== '') ? column.statusColor : this.defaultBackgroundcolor;
          return {
            ...column,
            deals: [],
            tasks: [],
            page: -1, // Initialize to -1 to load page 0 first
            totalPages: 0,
            loading: false,
            total: 0,
            backgroundColorAdjusted: this.getAdjustedColor(statusColor, 95, 0.5),
            borderColorAdjusted: '4px solid ' + this.getAdjustedColor(statusColor, 60)
          };
        });

        this.connectedList = [];
        this.leadStatusList.forEach((column, i) => {
          this.connectedList.push(column.statusId.toString());
          this.getLeadForColumn(column, i);
        });

      },
      error => {
        console.log("Error fetching Lead Status", error);
      }
    );
  }

  getAdjustedColor(
    color: string,
    targetLightness: number,
    saturationAdjustmentFactor: number = 0
  ): string {
    const hex = this.parseColorToHex(color);

    const r = parseInt(hex.substring(1, 3), 16) / 255;
    const g = parseInt(hex.substring(3, 5), 16) / 255;
    const b = parseInt(hex.substring(5, 7), 16) / 255;

    const max = Math.max(r, g, b),
      min = Math.min(r, g, b);
    let h: number = 0,
      s: number,
      l: number = (max + min) / 2;

    if (max === min) {
      h = s = 0;
    } else {
      const d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      switch (max) {
        case r:
          h = (g - b) / d + (g < b ? 6 : 0);
          break;
        case g:
          h = (b - r) / d + 2;
          break;
        case b:
          h = (r - g) / d + 4;
          break;
      }
      h /= 6;
    }

    const targetL = targetLightness / 100;

    const blendFactor = 0.6;
    let newL = l + (targetL - l) * blendFactor;


    newL = Math.max(0, Math.min(1, newL));
    let newS = s;
    if (newL * 100 > 90 && s > 0.1) { // Only adjust if not already desaturated

      const lightnessProximityToWhite = (newL * 100 - 90) / 10;
      newS = s * (1 - lightnessProximityToWhite * saturationAdjustmentFactor);
      newS = Math.max(0, newS);
    }


    return `hsl(${(h * 360).toFixed(0)}, ${(newS * 100).toFixed(0)}%, ${(newL * 100).toFixed(0)}%)`;
  }
  updateColor(column: any, newColor: string) {
    column.statusColor = newColor;
    this.cdr.markForCheck();
  }

  private parseColorToHex(color: string): string {

    const div = document.createElement('div');
    div.style.color = color;
    document.body.appendChild(div);


    const computed = window.getComputedStyle(div).color;
    document.body.removeChild(div);

    const rgb = computed.match(/\d+/g).map(Number);
    return '#' + rgb.map(x => {
      const hex = x.toString(16);
      return hex.length === 1 ? '0' + hex : hex;
    }).join('');
  }


  sortParams: any = 'updatedDate' + "," + Constant.Dsc;


  statusMap = new Map<string, any[]>();
  connectedList: any = [];
  getLeadForColumn(column: any, i: number) {
    if (column.loading || (column.totalPages && column.page >= column.totalPages - 1)) return;

    column.loading = true;
    const nextPage = column.page + 1;

    let search = 'statusName:*' + column.statusName + ",*";

    if (this.contactPage) {
      search += " AND isClosedWon:*1,*";
    }

    if (this.connectedCall && this.connectedLeadIds && this.connectedLeadIds.length > 0) {
      if (this.connectedLeadIds.length === 1) {
        search += " AND entityId$n:" + this.connectedLeadIds[0];
      } else {
        search += " AND entityId:" + this.connectedLeadIds.join(',');
      }
    }

    let url = this.router.url;
    let cleanUrl = url.split('?')[0];
    let searchTerm = localStorage.getItem(cleanUrl + "se")
    if (searchTerm != undefined && searchTerm != null && searchTerm != '') {
      search += " AND (" + searchTerm + ")";
    }

    this.spinner = true;
    this.productService.getLeadBySearch(search, nextPage, this.size, this.sortParams).subscribe(
      res => {
        this.spinner = false;
        column.tasks = [...column.tasks, ...res['content']];
        column.page = nextPage;
        column.totalPages = res['totalPages'];
        column.total = res['totalElements'];
        column.loading = false;
        this.loaderService.hide();
        this.cdr.markForCheck();
      },
      error => {
        this.spinner = false;
        column.loading = false;
        this.cdr.markForCheck();
      })
  }

  onColumnScroll(event: any, column: any, index: number) {
    const container = event.target;
    const scrollThreshold = 100;

    if (container.scrollHeight - container.scrollTop - container.clientHeight <= scrollThreshold) {
      this.getLeadForColumn(column, index);
    }
  }

  public drop(event: CdkDragDrop<string[]>): void {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex);

      this.leadStatusList.forEach(statusObject => {
        if (event.container.id == statusObject.statusId) {

          let taskIndex = event.currentIndex;

          if (statusObject.tasks && statusObject.tasks.length > taskIndex) {
            this.updateLeadStatus(statusObject, taskIndex);
          }
        }
      });

    }
  }

  updateLeadStatus(lead_id, taskIndex: number) {

    this.spinner = true;
    let object = {
      "LeadStatus": lead_id.statusId,
      "entityId": lead_id.tasks[taskIndex].entityId
    }

    this.loaderService.show();
    this.leadService.editLead(object, lead_id.tasks[taskIndex].entityId).subscribe(
      (response) => {
        this.spinner = false;
        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {

          this.getLeadStatus();
        } else {

          this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
        }
        this.loaderService.hide();
      },
      (err) => {
        console.log(err)
        this.loaderService.hide();
      });
  }

  getAllCrmData() {
    const encryptedData = localStorage.getItem('crmSettingsData');
    if (encryptedData) {
      try {
        const decrypted = this.ecryptService.decryptionAES(encryptedData);
        const data = JSON.parse(decrypted);

        if (data != null) {

          if (data['leadDetailPageType'] != undefined) {
            this.leadDetailPageType = data['leadDetailPageType'];
          } else {
            this.leadDetailPageType = 0;
          }
          this.crmType = data['crmType'];
          this.templateDisplayed = data['templateDisplayed'];
          this.whatsAppCustomUrl = data['whatsAppCustomUrl'];
          this.whatAppUrl = data['whatAppUrl'];
          this.dialerType = data['dialerType'];
          this.leadDetailType = data['leadDetailType'];
          localStorage.setItem(Constant.LEAD_POPUP, data['enableInCallNotification']);


        } else {
          this.leadDetailPageType = 0;
        }
      }
      catch (error) {
        console.error("Failed to decrypt crmSettingsData:", error);
      }
    }
  }

  templateDisplayed: any;
  init: boolean = false;
  leadActivityList: any = [];

  addLeadActivity(activityType: string, activityId, leadObject: any) {
    if (window.innerWidth > 768) {

      let dialogRef = this.dialog.open(ConversationPopupComponent, {
        width: '790px',
        disableClose: true,
        data: {
          "activityType": activityType,
          "type": "lead",
          "leadId": this.leadId,
          "activityId": activityId,
          "leadObject": leadObject,
          "templateDisplayed": this.templateDisplayed,
          "taskSaveType": 1
        }
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {
          this.init = false;
          this.getAllLeadActivity(this.leadId);

        }
      });

    }
    else {
      let dialogRef = this.dialog.open(ConversationPopupComponent, {
        minWidth: '100vw', height: '100vh',
        data: {
          "activityType": activityType,
          "leadId": this.leadId,
          "activityId": activityId,
          "leadObject": leadObject,
          "type": "lead",
          "templateDisplayed": this.templateDisplayed,
          "taskSaveType": 1
        },
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {
          this.init = false;
          this.getAllLeadActivity(this.leadId);

        }
      });
    }

  }

  getAllLeadActivity(leadId) {
    this.init = false;
    this.leadActivityService.getAllLeadActivityByLeadId(leadId).subscribe(
      data => {
        this.leadActivityList = data;
        this.init = true;

      },
      error => {
      })
  }

  add_Lead(lead) {
    console.log(lead.entityId);
    this.leadId = lead.entityId;
  }


  phonewhatsapp(data) {

    if (this.whatsAppCustomUrl == 0) {
      let message = `Hi ${data.name}, I'm from ${this.storeName}.\n`;

      if (!this.storeNameAdded) {
        message = `Hi ${data.name}`;
      }

      let url = `https://api.whatsapp.com/send?phone= ${encodeURIComponent(data.phoneNumber)}&text=${encodeURIComponent(message)}`;
      window.open(url, '_blank');
    } else if (this.whatsAppCustomUrl == 2) {
      let contactUid = data?.whatsappContactUid || data?.contactUid || data?.uid;
      let rawPhone = data?.phoneNumber || data?.mobile || data?.phone || '';
      let phoneNumber = rawPhone ? rawPhone.toString().replace(/\D/g, "") : '';
      let target = contactUid || phoneNumber;

      if (target) {
        this.dialog.closeAll();
        this.router.navigate(['/whatsAppChat'], { queryParams: { contact: target } });
      } else {
        alert("Contact information not available");
      }
    } else {
      let url = this.whatAppUrl;
      window.open(url, '_blank');
    }
    this.dialog.closeAll();
  }

  phoneNumbercall(data) {

    if (this.dialerType == 1) {
      this.leadActivityService.makeCall(data).subscribe(
        response => {
          if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
            this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 300 });
            this.dialog.closeAll();
          } else {
            this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 300 });
          }
          this.dialog.closeAll();
        },
        error => {

        });
    }
    else if (this.dialerType == 2) {
      this.opendialCall(data)
      this.callANumber(data, data.phoneNumber)
    }

    else if (this.dialerType == 3) {
      this.loaderService.show();

      this.leadActivityService.makeDooctiClickToCall(data).subscribe(
        response => {
          if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
            this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 300 });


          } else {

            this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 300 });
          }
          this.loaderService.hide();

        },
        error => {
          this.loaderService.hide();
        });

      this.spinner = false;



    }
    else {

      let phonenumber;

      if (data.phoneNumber.includes('+')) {
        phonenumber = "tel:" + data.phoneNumber;
      } else {
        phonenumber = "tel:+" + data.phoneNumber;
      }

      window.location.href = phonenumber;

    }
  }

  dialerShow: boolean = false;
  data: Object;

  opendialCall(data) {
    document.getElementById("mydailer").style.display = "block";
    this.dialerShow = true;
    this.data = data
  }

  @ViewChild('myFrame') myFrame: ElementRef;
  callANumber(number, phone) {

    const iframeWindow = this.myFrame.nativeElement.contentWindow;

    window.addEventListener('message', this.receiveMessage.bind(this));

    console.log(number);

    const postData = {
      "entity_type": "Lead",
      "entity_id": number.entityId,
      "entity_name": number.name,
      "entity_number": phone.toString(),
      "tenant_id": "Account Id",
      "user_email": number.ownerEmail,
      "user_id": number.ownerId,
      "user_number": "362"
    };

    iframeWindow.postMessage(postData, 'https://crm-app.doocti.com');
  }

  addContact() {

    this.crmsettingsService.getCrmSettingsData()
      .subscribe(
        (setting: any) => {
          const encryptedCrmSettings = this.ecryptService.encryptionAES(JSON.stringify(setting));
          localStorage.setItem('crmSettingsData', encryptedCrmSettings);
          this.getAllCrmData();

          this.defaultSet = setting['defaultSet'];

          let productId = 0;

          this.router.navigate([`lead/add-edit-lead/${productId}/${this.defaultSet}`])
        })

  }

  receiveMessage(event: MessageEvent) {
    if (event.origin !== 'https://crm-app.doocti.com') {
      return;
    }
    console.log('Received message from iframe:', event.data);
  }

  details(leadId, setId) {

    if (this.leadDetailType == 0) {
      this.router.navigate([`leadDetail/${leadId}`])
    } else {

      const url = this.router.serializeUrl(
        this.router.createUrlTree([`leadDetail/${leadId}`])
      );
      const relativeUrl = url.replace(window.location.origin, '');
      window.open(relativeUrl, '_blank');

    }

  }

  editProduct(leadId, setId) {

    this.router.navigate([`lead/add-edit-lead/${leadId}/${setId}`])

  }

  refersh(column, i) {

    this.loaderService.show();
    column.tasks = [];
    column.page = -1;
    column.totalPages = 0;
    this.getLeadForColumn(column, i);

  }

  deleteLeadById(id: any) {
    if (!this.resourcePrivilege?.delete) {
      return;
    }

    this.loaderService.show();

    this.productService.deleteByLeadId(id).subscribe(
      response => {
        this.loaderService.hide();
        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
          this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
          this.getLeadStatus();
        } else {
          this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
        }

      },
      error => {
        this.loaderService.hide();
      })

  }


  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

  protected _onDestroy = new Subject<void>();

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }


  getButtonText() {
    if (this.router.url.includes('contact')) {
      return 'Add Contact';
    }
    return 'Add Lead';
  }
}  